// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n_2z","question":"styles_question__2Dzyv","inputVisibleButton":"styles_inputVisibleButton__2kuuN","note":"styles_note__3b9EU"};